import { sessionIdName } from 'const/session'
import { setAppSessionItem } from 'helpers/appSessionItem'
import { setCookie } from 'helpers/cookie'

/**
 * Sets the auth session id value in session storage.
 * @param value session id / correlation id / interaction id string for api requests
 */
const setSessionID = (value: string): void => {
  // empty prefix to make session id cross trackable
  setAppSessionItem(sessionIdName, value, '')
  setCookie(sessionIdName, value)
}

export default setSessionID
